import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import settings from "settings"
import _ from "lodash"
import moment from "moment"
import EditSalespersonModal from "../modals/editSalesperson"
import EditSalesManagerModal from "../modals/editSalesManager"
import EditDevUser from "../modals/editDevUser"
import AddDevUser from "../modals/addDevUser"
import EditARCModal from "../modals/editARCUser"
import EditSuperintendentModal from "../modals/editSuperintendentUser"
import AddARCModal from "../modals/addARCUser"
import AddSuperintendentModal from "../modals/addSuperintendentUser"
import AddSalesperson from "../modals/addSalesperson"
import AddSalesManagerModal from "../modals/addSalesManager"
import MassModuleUpdate from "../modals/massModuleUpdate"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"

class UserManagement extends Component {
	constructor(props) {
		super(props)

		this.state = {
			editSalespersonModal: false,
			editARCModal: false,
			editDevModal: false,
			editSalesManagerModal: false,
			addDevUserModal: false,
			addSalespersonModal: false,
			addSalesManagerModal: false,
			massModuleUpdate: false,
			addARCModal: false,
			addSuperintendentModal: false,
			editSuperintendentModal: false,
			userData: {},
			devUserData: {},
			salespersonUserData: {},
			arcUserData: {},
			superintendentUserData: {},
			salesManagerUserData: {},
			salespeopleColumns: [
				{
					Header: "Name",
					accessor: "name",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Email",
					accessor: "email",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "email"),
				},
				{
					Header: "Builder",
					accessor: "builders",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "builders"),
				},
				{
					Header: "Properties",
					accessor: "properties",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "properties"),
					Cell: (v) => helpers.truncate(v.value, 100),
				},
				{
					Header: "Office",
					accessor: "office",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "office"),
				},
				{
					Header: "Cell",
					accessor: "cell",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "cell"),
				},
				{
					Header: "Lot Types",
					accessor: "lot_types",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_types"),
				},
				{
					Header: "Status",
					accessor: "status",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				{
					Header: "Notes",
					accessor: "notes",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "notes"),
				},
				{
					Header: "Added Date",
					accessor: "addedDate",
					show: true,
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					sort: "desc",
				},
				{
					Header: "Added By",
					accessor: "addedBy",
					show: true,
					sort: "desc",
				},
				{
					Header: "View",
					accessor: "view",
					show: true,
				},
			],
			salesManagerColumns: [
				{
					Header: "Name",
					accessor: "name",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Email",
					accessor: "email",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "email"),
				},
				{
					Header: "Builder",
					accessor: "builders",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "builders"),
				},
				{
					Header: "Properties",
					accessor: "properties",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "properties"),
					Cell: (v) => helpers.truncate(v.value, 100),
				},
				{
					Header: "Status",
					accessor: "status",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				{
					Header: "Over Salespeople",
					accessor: "overSalespeople",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "overSalespeople"),
					Cell: (v) => helpers.truncate(v.value, 100),
				},
				{
					Header: "Email Reminders",
					accessor: "reminders",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "reminders"),
				},
				{
					Header: "Input Paperwork?",
					accessor: "paperwork",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "paperwork"),
				},
				{
					Header: "Paperwork Only",
					accessor: "paperwork_only",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "paperwork_only"),
				},
				{
					Header: "Notes",
					accessor: "notes",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "notes"),
				},
				{
					Header: "Added Date",
					accessor: "addedDate",
					show: true,
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					sort: "desc",
				},
				{
					Header: "Added By",
					accessor: "addedBy",
					show: true,
					sort: "desc",
				},
				{
					Header: "View",
					accessor: "view",
					show: true,
				},
			],
			arcColumns: [
				{
					Header: "Name",
					accessor: "name",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Email",
					accessor: "email",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "email"),
				},
				{
					Header: "Builder",
					accessor: "builders",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "builders"),
				},
				{
					Header: "Properties",
					accessor: "properties",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "properties"),
					Cell: (v) => helpers.truncate(v.value, 100),
				},
				{
					Header: "Status",
					accessor: "status",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				{
					Header: "Notes",
					accessor: "notes",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "notes"),
				},
				{
					Header: "Added Date",
					accessor: "addedDate",
					show: true,
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					sort: "desc",
				},
				{
					Header: "Added By",
					accessor: "addedBy",
					show: true,
					sort: "desc",
				},
				{
					Header: "View",
					accessor: "view",
					show: true,
				},
			],
			devColumns: [
				{
					Header: "Name",
					accessor: "name",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Email",
					accessor: "email",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "email"),
				},
				{
					Header: "Properties",
					accessor: "properties",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "properties"),
					Cell: (v) => helpers.truncate(v.value, 100),
				},
				{
					Header: "Status",
					accessor: "status",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				{
					Header: "Notes",
					accessor: "notes",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "notes"),
				},
				{
					Header: "View As Permission",
					accessor: "viewAs",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "viewAs"),
				},
				{
					Header: "Added Date",
					accessor: "addedDate",
					show: true,
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
					sort: "desc",
				},
				{
					Header: "Added By",
					accessor: "addedBy",
					show: true,
					sort: "desc",
				},
				{
					Header: "View",
					accessor: "view",
					show: true,
				},
			],
			superintendentColumns: [
				{
					Header: "Name",
					accessor: "name",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Email",
					accessor: "email",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "email"),
				},
				{
					Header: "Builder",
					accessor: "builders",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "builders"),
				},
				{
					Header: "Properties",
					accessor: "properties",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "properties"),
					Cell: (v) => helpers.truncate(v.value, 100),
				},
				{
					Header: "Status",
					accessor: "status",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				{
					Header: "Notes",
					accessor: "notes",
					show: true,
					filterMethod: (f, r) => helpers.tableText(f, r, "notes"),
				},
				{
					Header: "Added Date",
					accessor: "addedDate",
					show: true,
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					sort: "desc",
				},
				{
					Header: "Added By",
					accessor: "addedBy",
					show: true,
					sort: "desc",
				},
				{
					Header: "View",
					accessor: "view",
					show: true,
				},
			],
		}
	}

	closeModal = (d) => {
		this.setState({
			editSalespersonModal: false,
			editDevModal: false,
			editSalesManagerModal: false,
			addDevUserModal: false,
			addSalespersonModal: false,
			addSalesManagerModal: false,
			addARCModal: false,
			editARCModal: false,
			addSuperintendentModal: false,
			editSuperintendentModal: false,
			massModuleUpdate: false,
		})
	}

	buildSalespeopleTable = () => {
		let ret = []
		_.forEach(this.props.payload.users, (r) => {
			//console.log(r)
			if (r.group !== settings.groups.salespeople) {
				return
			}
			let builders = ""
			if (r.builders) {
				let builderNames = []
				_.map(r.builders, (v) => {
					let b = _.find(this.props.payload.public.builders, { id: v })
					if (b) {
						builderNames.push(b.name)
					}
				})
				builders = builderNames.join(", ")
			}
			let properties = ""
			if (r.properties) {
				let propNames = []
				_.map(r.properties, (v) => {
					let b = _.find(this.props.payload.public.properties, { id: v })
					if (b) {
						propNames.push(b.name)
					}
				})
				properties = propNames.join(", ")
				//properties = helpers.truncate(properties, 100)
			}
			let neighborhoods = ""
			if (r.neighborhoods) {
				let propNames = []
				_.map(r.neighborhoods, (v) => {
					let b = _.find(this.props.payload.public.neighborhoods, { id: v })
					if (b) {
						propNames.push(b.name)
					}
				})
				neighborhoods = propNames.join(", ")
			}
			let addedUser = _.find(this.props.payload.users, { id: r.addedBy })
			if (addedUser) {
				r.addedUserName = `${addedUser.first} ${addedUser.last}`
			}

			let types = ""
			_.forEach(r.lot_types, (v) => {
				let type = _.find(this.props.payload.public.lot_types, { id: parseInt(v) })
				if (type) types += `${type.name}, `
			})
			types = _.trim(types, ", ")

			let f = {
				name: `${r.first} ${r.last}`,
				first: r.first,
				last: r.last,
				email: r.email,
				notes: r.notes,
				builders: builders,
				properties: properties,
				status: r.status == 0 ? "Disabled" : "Enabled",
				neighborhoods: neighborhoods,
				addedDate: r.addedDate,
				addedBy: r.addedUserName,
				office: r.office,
				cell: r.cell,
				lot_types: types,
				view: (
					<a
						onClick={() => {
							this.setState({ salespersonUserData: r, editSalespersonModal: true })
						}}>
						<i className="far fa-edit"></i>
					</a>
				),
			}
			ret.push(f)
		})
		return ret
	}

	buildARCTable = () => {
		let ret = []
		_.forEach(this.props.payload.users, (r) => {
			//console.log(r)
			if (r.group !== settings.groups.arc) {
				return
			}
			let builders = ""
			if (r.builders) {
				let builderNames = []
				_.map(r.builders, (v) => {
					let b = _.find(this.props.payload.public.builders, { id: v })
					if (b) {
						builderNames.push(b.name)
					}
				})
				builders = builderNames.join(", ")
			}
			let properties = ""
			if (r.properties) {
				let propNames = []
				_.map(r.properties, (v) => {
					let b = _.find(this.props.payload.public.properties, { id: v })
					if (b) {
						propNames.push(b.name)
					}
				})
				properties = propNames.join(", ")
				//properties = helpers.truncate(properties, 100)
			}
			let addedUser = _.find(this.props.payload.users, { id: r.addedBy })
			if (addedUser) {
				r.addedUserName = `${addedUser.first} ${addedUser.last}`
			}

			let types = ""
			_.forEach(r.lot_types, (v) => {
				let type = _.find(this.props.payload.public.lot_types, { id: parseInt(v) })
				if (type) types += `${type.name}, `
			})
			types = _.trim(types, ", ")

			let f = {
				name: `${r.first} ${r.last}`,
				first: r.first,
				last: r.last,
				email: r.email,
				notes: r.notes,
				builders: builders,
				properties: properties,
				status: r.status == 0 ? "Disabled" : "Enabled",
				addedDate: r.addedDate,
				addedBy: r.addedUserName,
				view: (
					<a
						onClick={() => {
							this.setState({ arcUserData: r, editARCModal: true })
						}}>
						<i className="far fa-edit"></i>
					</a>
				),
			}
			ret.push(f)
		})
		return ret
	}

	buildSuperintendentTable = () => {
		let ret = []
		_.forEach(this.props.payload.users, (r) => {
			//console.log(r)
			if (r.group !== 15) {
				return
			}
			let builders = ""
			if (r.builders) {
				let builderNames = []
				_.map(r.builders, (v) => {
					let b = _.find(this.props.payload.public.builders, { id: v })
					if (b) {
						builderNames.push(b.name)
					}
				})
				builders = builderNames.join(", ")
			}
			let properties = ""
			if (r.properties) {
				let propNames = []
				_.map(r.properties, (v) => {
					let b = _.find(this.props.payload.public.properties, { id: v })
					if (b) {
						propNames.push(b.name)
					}
				})
				properties = propNames.join(", ")
				//properties = helpers.truncate(properties, 100)
			}
			let addedUser = _.find(this.props.payload.users, { id: r.addedBy })
			if (addedUser) {
				r.addedUserName = `${addedUser.first} ${addedUser.last}`
			}

			let types = ""
			_.forEach(r.lot_types, (v) => {
				let type = _.find(this.props.payload.public.lot_types, { id: parseInt(v) })
				if (type) types += `${type.name}, `
			})
			types = _.trim(types, ", ")

			let f = {
				name: `${r.first} ${r.last}`,
				first: r.first,
				last: r.last,
				email: r.email,
				notes: r.notes,
				builders: builders,
				properties: properties,
				status: r.status == 0 ? "Disabled" : "Enabled",
				addedDate: r.addedDate,
				addedBy: r.addedUserName,
				view: (
					<a
						onClick={() => {
							this.setState({ superintendentUserData: r, editSuperintendentModal: true })
						}}>
						<i className="far fa-edit"></i>
					</a>
				),
			}
			ret.push(f)
		})
		return ret
	}

	buildSalesManagerTable = () => {
		let ret = []
		_.forEach(this.props.payload.users, (r) => {
			if (r.group !== settings.groups.sales_managers) {
				return
			}
			let builders = ""
			if (r.builders) {
				let builderNames = []
				_.map(r.builders, (v) => {
					let b = _.find(this.props.payload.public.builders, { id: v })
					if (b) {
						builderNames.push(b.name)
					}
				})
				builders = builderNames.join(", ")
			}
			let properties = ""
			if (r.properties) {
				let propNames = []
				_.map(r.properties, (v) => {
					let b = _.find(this.props.payload.public.properties, { id: v })
					if (b) {
						propNames.push(b.name)
					}
				})
				properties = propNames.join(", ")
				//properties = helpers.truncate(properties, 100)
			}
			let salespeople = ""
			if (r.overSalespeople) {
				let propNames = []
				_.forEach(r.overSalespeople, (v) => {
					let b = _.find(this.props.payload.public.salespeople, { id: v })
					if (!b || b.status == 0) return
					if (b) {
						propNames.push(`${b.first} ${b.last}`)
					}
				})
				salespeople = propNames.join(", ")
				//salespeople = helpers.truncate(salespeople, 100)
			}
			let addedUser = _.find(this.props.payload.users, { id: r.addedBy })
			if (addedUser) {
				r.addedUserName = `${addedUser.first} ${addedUser.last}`
			}
			let f = {
				name: `${r.first} ${r.last}`,
				first: r.first,
				last: r.last,
				email: r.email,
				builders: builders,
				notes: r.notes,
				properties: properties,
				overSalespeople: salespeople,
				status: r.status == 0 ? "Disabled" : "Enabled",
				addedDate: r.addedDate,
				addedBy: r.addedUserName,
				reminders: r.manager_email ? "Yes" : "No",
				paperwork: r.manager_paperwork ? "Yes" : "No",
				paperwork_only: r.paperwork_only ? "Yes" : "No",
				view: (
					<a
						onClick={() => {
							this.setState({ salesManagerUserData: r, editSalesManagerModal: true })
						}}>
						<i className="far fa-edit"></i>
					</a>
				),
			}
			ret.push(f)
		})
		return ret
	}

	buildDevTable = () => {
		let ret = []
		_.forEach(this.props.payload.users, (r) => {
			//console.log(r)
			if (r.group !== settings.groups.dev) {
				return
			}
			let builders = ""
			if (r.builders) {
				let builderNames = []
				_.map(r.builders, (v) => {
					let b = _.find(this.props.payload.public.builders, { id: v })
					if (b) {
						builderNames.push(b.name)
					}
				})
				builders = builderNames.join(", ")
			}
			let properties = ""
			if (r.properties) {
				let propNames = []
				_.map(r.properties, (v) => {
					let b = _.find(this.props.payload.public.properties, { id: v })
					if (b) {
						propNames.push(b.name)
					}
				})
				properties = propNames.join(", ")
				//properties = helpers.truncate(properties, 100)
			}
			let addedUser = _.find(this.props.payload.users, { id: r.addedBy })
			if (addedUser) {
				r.addedUserName = `${addedUser.first} ${addedUser.last}`
			}

			let modules = []
			if (r.modules && r.modules[0] == "*") {
				modules = "Super"
			} else {
				_.forEach(r.modules, (v) => {
					let module = _.find(this.props.payload.public.loadedModules, { id: v })
					if (module) {
						modules.push(module.name)
					}
				})
				if (modules.length > 0) {
					modules = modules.join(",")
				}
			}

			let f = {
				name: `${r.first} ${r.last}`,
				first: r.first,
				last: r.last,
				email: r.email,
				status: r.status == 1 ? "Enabled" : "Disabled",
				viewAs: r.viewAsPermission == 1 ? "Yes" : "No",
				notes: r.notes,
				builders: builders,
				properties: properties,
				addedDate: r.addedDate,
				addedBy: r.addedUserName,
				modules: modules,
				view: (
					<a
						onClick={() => {
							this.setState({ devUserData: r, editDevModal: true })
						}}>
						<i className="far fa-edit"></i>
					</a>
				),
			}
			ret.push(f)
		})
		return ret
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="userManagement">
					<Title title="User Management" showDate={false} />
					<div className="content">
						<h2>Salespeople</h2>
						<div className="admin__add">
							<i
								className="fas fa-plus-circle"
								onClick={() => {
									this.setState({ addSalespersonModal: true })
								}}
							/>
						</div>
						<FullTable
							data={this.buildSalespeopleTable()}
							columns={this.state.salespeopleColumns}
							name="salespeople"
							title="Salespeople"
							unset={["view"]}
							classNames={"small"}
						/>
						<h2>Sales Managers</h2>
						<div className="admin__add">
							<i
								className="fas fa-plus-circle"
								onClick={() => {
									this.setState({ addSalesManagerModal: true })
								}}
							/>
						</div>
						<FullTable
							data={this.buildSalesManagerTable()}
							columns={this.state.salesManagerColumns}
							name="salesManagers"
							title="Sales Managers"
							unset={["view"]}
							classNames={"small"}
						/>
						<h2>Development Users</h2>
						<div className="admin__add">
							<i
								className="fas fa-plus-circle"
								onClick={() => {
									this.setState({ addDevUserModal: true })
								}}
							/>
							<i
								className="fas fa-user-circle"
								style={{ marginLeft: 10 }}
								onClick={() => {
									this.setState({ massModuleUpdate: true })
								}}
							/>
						</div>
						<FullTable
							data={this.buildDevTable()}
							columns={this.state.devColumns}
							name="devUsers"
							title="Development Users"
							unset={["view"]}
							classNames={"small"}
						/>
						{settings.arc && (
							<>
								<h2>ARC Users</h2>
								<div className="admin__add">
									<i
										className="fas fa-plus-circle"
										onClick={() => {
											this.setState({ addARCModal: true })
										}}
									/>
								</div>
								<FullTable
									data={this.buildARCTable()}
									columns={this.state.arcColumns}
									name="arcUsers"
									title="ARC Users"
									unset={["view"]}
									classNames={"small"}
								/>
								<AddARCModal
									open={this.state.addARCModal}
									close={this.closeModal}
									onClose={(d) => {
										this.closeModal(d)
									}}
								/>
								<EditARCModal
									open={this.state.editARCModal}
									data={this.state.arcUserData}
									close={this.closeModal}
									onClose={(d) => {
										this.closeModal(d)
									}}
								/>

								<h2>Superintendent Users</h2>
								<div className="admin__add">
									<i
										className="fas fa-plus-circle"
										onClick={() => {
											this.setState({ addSuperintendentModal: true })
										}}
									/>
								</div>
								<FullTable
									data={this.buildSuperintendentTable()}
									columns={this.state.superintendentColumns}
									name="superintendentUsers"
									title="Superintendent Users"
									unset={["view"]}
									classNames={"small"}
								/>
								<AddSuperintendentModal
									open={this.state.addSuperintendentModal}
									close={this.closeModal}
									onClose={(d) => {
										this.closeModal(d)
									}}
								/>
								<EditSuperintendentModal
									open={this.state.editSuperintendentModal}
									data={this.state.superintendentUserData}
									close={this.closeModal}
									onClose={(d) => {
										this.closeModal(d)
									}}
								/>
							</>
						)}
						<MassModuleUpdate
							open={this.state.massModuleUpdate}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
						<AddSalesManagerModal
							open={this.state.addSalesManagerModal}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
						<EditSalesManagerModal
							open={this.state.editSalesManagerModal}
							data={this.state.salesManagerUserData}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
						<EditSalespersonModal
							open={this.state.editSalespersonModal}
							data={this.state.salespersonUserData}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
						<EditDevUser
							open={this.state.editDevModal}
							data={this.state.devUserData}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
						<AddDevUser
							open={this.state.addDevUserModal}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
						<AddSalesperson
							open={this.state.addSalespersonModal}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(UserManagement)
